<template>
  <v-flex
    class="drag_and_drop"
    :class="isDesktop ? 'mx-10' : 'mx-5'"
  >
    <div
      class="drag_and_drop__area"
      @dragover="dragover"
      @dragleave="dragleave"
      @drop="onDrop"
    >
      <div class="d-flex justify-center full_width">
        <input
          ref="fileInput"
          class="d-none"
          type="file"
          @change="onDropFile"
          accept="image/png, image/jpeg"
        />
        <img
          class="mb-6"
          alt="upload icon"
          src="assets/icons/upload-icon.svg"
        >
      </div>
      <div class="d-flex justify-center full_width">
        <p>{{ $t('step-one.drop-field.text') }}</p>
      </div>
      <div class="d-flex justify-center full_width">
        <v-btn
          class="primary_button"
          @click="$refs.fileInput.click()"
          @change="onDropFile"
        >
          {{ $t('step-one.drop-field.button') }}
        </v-btn>
      </div>
    </div>

    <loading-modal ref="LoadingModal"/>
  </v-flex>
</template>

<script>
import FileService from "@/services/FileService";
import LoadingModal from "@/components/home/loading-modal"

export default {
  name: "StepOneComponent",
  mixins: [FileService],
  components: {
    'loading-modal': LoadingModal
  },
  data() {
    return {
      file: null,
      imageId: null,
      timer: null,
      isConvertImage: false,
      isConverted: false
    }
  },
  methods: {
    onDrop(event) {
      event.preventDefault();
      this.$refs.fileInput.files = event.dataTransfer.files;
      this.onDropFile();
      event.currentTarget.classList.remove('drop_background');
    },
    onDropFile() {
      this.file = this.$refs.fileInput.files[0]
      this.uploadImage()
    },
    dragover(event) {
      event.preventDefault();
      if (!event.currentTarget.classList.contains('drop_background')) {
        event.currentTarget.classList.add('drop_background');
      }
    },
    dragleave(event) {
      event.currentTarget.classList.remove('drop_background');
    },
    uploadImage() {
      if (!this.file) return false;
      this.isConvertImage = true
      this.$refs.LoadingModal.isModalOpen = true
      const payload = new FormData
      payload.append('file', this.file, 'newImage')

      this.uploadFileForConvert(payload)
        .then((response) => {
          this.imageId = response.data
          this.file = null
          this.getSvgFile()
        })
        .catch((err) => {
          this.isConvertImage = false
          console.log('error', err)
          this.onCallToastr('error', 'Something went wrong, please try again later', 'Failed!')
        })
    },
    getSvgFile() {
      const counter = 0
      this.recursiveConversionRequest(counter)
    },
    recursiveConversionRequest(counter) {
      counter++
      if (counter > 200) {
        this.isConvertImage = false
        clearTimeout(this.timer)
        return false;
      }

      this.checkConvertToSvg()
      if (!this.isConverted) {
        this.timer = setTimeout(() => {
          this.recursiveConversionRequest(counter)
        }, 500)
      } else {
        clearTimeout(this.timer)
        this.$refs.LoadingModal.isModalOpen = false
        this.$emit('isConverted', this.imageId)
        this.isConvertImage = false
      }
    },
    checkConvertToSvg() {
      const params = {
        'unique_id': this.imageId
      }
      this.checkToCovertFile(params)
        .then((response) => {
          this.isConverted = !!response.data
        })
        .catch((err) => {
          this.isConvertImage = false
          console.log('error', err)
          this.onCallToastr('error', 'Something went wrong, please try again later', 'Failed!')
        })
    }
  }
}
</script>
